<template>
    <div>
        <div :id="'customToolbar'+idDefault" class="-ml-4">

            <select class="ql-font" aria-label="Fuente">
              <option selected>Por defecto</option>
              <option value="serif">Serif</option>
              <option value="sans-serif">Sans Serif</option>
              <option value="monospace">Monospace</option>
            </select>

            <select class="ql-header" aria-label="Tamaño de letra">
              <option selected></option>
              <option value="1"></option>
              <option value="2"></option>
              <option value="3"></option>
              <option value="4"></option>
              <option value="5"></option>
              <option value="6"></option>
            </select>
            <button aria-label="Negrita" class="ql-bold"></button>
            <button aria-label="Cursiva" class="ql-italic"></button>
            <button aria-label="Subrayado" class="ql-underline"></button>
            <button aria-label="Tachado" class="ql-strike"></button>

            <button aria-label="Alinear a la izquierda" class="ql-align" value=""></button>
            <button aria-label="Alinear al centro" class="ql-align" value="center"></button>
            <button aria-label="Alinear a la derecha" class="ql-align" value="right"></button>
            <button aria-label="Justificar" class="ql-align" value="justify"></button>

            <button aria-label="Lista ordenada" class="ql-list" value="ordered"></button>
            <button aria-label="Lista viñetas 1" class="ql-list" value="bullet"></button>
            <button aria-label="Lista viñetas 2" class="ql-list" value="check"></button>

            <select class="ql-color" aria-label="Color de texto">
            </select>

            <select class="ql-background" aria-label="Color de fondo">
            </select>

            <button aria-label="Insertar enlace" class="ql-link"></button>

            <button aria-label="Añadir imagen" @click.stop.prevent="toggleAddImage">
              <svg viewBox="0 0 18 18"
                title="Añadir imagen"
                > 
                <rect class="ql-stroke" height="10" width="12" x="3" y="4"></rect> 
                <circle class="ql-fill" cx="6" cy="7" r="1"></circle> 
                <polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline> 
              </svg>
            </button>

            <button aria-label="Exportar html" @click.stop.prevent="exportHtml">
              <svg  viewBox="0 0 18 18" 
                title="Exportar html"
                >
                <path class="ql-fill ql-stroke" d="M4 9l5 5l4 -5"></path>
                <path class="ql-fill ql-stroke" d="M9 4l0 12"></path>
                <line class="ql-stroke" x1="15" x2="3" y1="16" y2="16"></line>
              </svg>  
            </button>

            <button aria-label="Limpiar formato del texto seleccionado" class="ql-clean"></button>

            <button aria-label="Insertar etiqueta" @click.stop.prevent="toggleInsertTag">
              <svg viewBox="0 0 24 24" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"
                title="Insertar tag"
                >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path class="ql-stroke" d="M7.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                <path class="ql-stroke" d="M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3z"></path>
              </svg>
            </button>

          </div>
          
          <div>
            <VueEditor 
              :disabled="disableEditor"
              :id="idDefault"
              ref="vEditor"
              v-model="content" 
              :editorOptions="editorOptions"
               @focus="onEditorFocus"
              />
            <!-- Debug content -->
            <!-- <div>{{ content }}</div> -->
          </div>
        <BaseElDialog
            title="Indique el enlace (URL) de su imagen"
            :visible.sync="showModalUrl"
            @open="handleOpenModalDialog([
              'container-handleOpenModal-url-body',
              'container-handleOpenModal-url',
              ])"
            @closed="releaseFocusDialog"
            width="40%"
            custom-class="min-width-dialog"
            center
            :show-close="false">
            <div 
              class="overflow-x-hidden"
              ref="container-handleOpenModal-url-body"
              >
              <el-form
                :model="form"
                ref="ruleFormUrl"
                :rules="rules"
              >
                <div class="lg:mb-2">
                  <div>
                    <span :id="'text-editor-url-label-' + idDefault" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.url')}}</span>
                      <el-form-item prop="url">
                        <el-input
                          :aria-labelledby="'text-editor-url-label-' + idDefault"
                          class="w-full"
                          v-model="form.url"
                          maxlength='1000'
                        >
                          <template v-if="form.url" slot="suffix">
                            <base-clear-input-button
                              aria-label="Limpiar campo de URL"
                              @clear="form.url = ''"
                            />
                          </template>
                        </el-input>
                      </el-form-item>
                  </div>
                </div>
              </el-form>
            </div>
            <template slot="footer" >
              <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-url">
                <base-button class="w-full" @click.stop.prevent="showModalUrl = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
                <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click.stop.prevent="() => {handleImageAdded('ruleFormUrl')}"/>
              </div>
            </template>
        </BaseElDialog>
        <BaseElDialog
            title="Inserción de etiqueta"
            :visible.sync="showModalTag"
            :close-on-click-modal="!isSelectDropdownOpen"
            @open="handleOpenModalDialog([
              'container-handleOpenModal-tag-body',
              'container-handleOpenModal-tag',
              ])"
            @closed="releaseFocusDialog"
            width="40%"
            custom-class="min-width-dialog"
            center
            :show-close="false">
            <div 
              class="overflow-x-hidden"
              ref="container-handleOpenModal-tag-body"
              >
              <el-form
                :model="form"
                ref="ruleForm"
                :rules="rules"
              >
                <div class="lg:mb-2">
                  <div>
                    <AccessibleElSelect
                      v-model="form.tag"
                      prop="tag"
                      :options="tagsForAccessibleSelect"
                      id-prefix="texteditor"
                    >
                      <template slot="label"><base-obligatory-icon/>{{$t('app.tag_metadato')}}</template>
                    </AccessibleElSelect>
                  </div>
                  <div v-if="isSelectedType2">
                    <span :id="'text-editor-aux-text-type2-label-' + idDefault" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.link_text')}}</span>
                      <el-form-item prop="auxText">
                        <el-input
                          :aria-labelledby="'text-editor-aux-text-type2-label-' + idDefault"
                          class="w-full"
                          v-model="form.auxText"
                          maxlength='100'
                        >
                          <template v-if="form.auxText" slot="suffix">
                            <base-clear-input-button
                              aria-label="Limpiar campo"
                              @clear="form.auxText = ''"
                            />
                          </template>
                        </el-input>
                      </el-form-item>
                  </div>
                  <div v-if="isSelectedType4">
                    <AccessibleElSelect
                      v-model="form.metadatoAdicional"
                      prop="metadatoAdicional"
                      :options="metadatosAdicionalesForAccessibleSelect"
                      id-prefix="texteditor"
                    >
                      <template slot="label"><base-obligatory-icon/>{{$t('app.metadata_single')}}</template>
                    </AccessibleElSelect>
                  </div>
                  <div v-if="isSelectedType3 || isSelectedType4">
                    <span :id="'text-editor-aux-text-type34-label-' + idDefault" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.previous_text')}}</span>
                      <el-form-item prop="auxText">
                        <el-input
                          :aria-labelledby="'text-editor-aux-text-type34-label-' + idDefault"
                          class="w-full"
                          v-model="form.auxText"
                          maxlength='100'
                        >
                          <template slot="append">{{tagSelected}}</template>
                          <template v-if="form.auxText" slot="suffix">
                            <base-clear-input-button
                              class="pt-2"
                              aria-label="Limpiar campo"
                              @clear="form.auxText = ''"
                            />
                          </template>
                        </el-input>
                      </el-form-item>
                  </div>
                </div>
              </el-form>
            </div>
            <template slot="footer" >
              <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-tag">
                <base-button class="w-full" @click.stop.prevent="showModalTag = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
                <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click.stop.prevent="() => {insertTag('ruleForm')}"/>
              </div>
            </template>
        </BaseElDialog>
    </div>
</template>
<script>
import { VueEditor, Quill } from 'vue2-editor'
import DOMPurify from 'dompurify'
import BaseElDialog from '@/components/base/BaseElDialog.vue'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
import { dropdownState } from '@/state/dropdownState'

// Configuración de DOMPurify para plantillas de email: permite HTML de formato
// y estilos inline, pero elimina event handlers y URIs javascript:
const EDITOR_PURIFY_CONFIG = {
  ALLOWED_TAGS: [
    'a', 'b', 'blockquote', 'br', 'caption', 'code', 'col', 'colgroup',
    'div', 'em', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr', 'i', 'img',
    'li', 'nl', 'ol', 'p', 'pre', 's', 'small', 'span', 'strike', 'strong',
    'sub', 'sup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'u', 'ul',
  ],
  ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'class', 'style', 'target', 'rel',
    'width', 'height', 'align', 'valign', 'colspan', 'rowspan', 'color'],
  ALLOW_DATA_ATTR: false,
}

var FontStyle = Quill.import('attributors/style/font')
FontStyle.whitelist = ['serif', 'sans-serif', 'monospace']
Quill.register(FontStyle, true)

export default {
  name: 'text-editor',
  props: {
    contentDefault: {
      type: String,
      default: '<h1>Editor de texto enriquecido</h1>'
    },
    idDefault: {
      type: String,
      default: 'texteditor1'
    },
    tags: {
      default: [
        {
          Nombre: 'Ejemplo',
          Tag: '#EJEMPLO#',
          idTipo: 1,
        }, 
      ],
    },
    metadatosAdicionales: {
      default: [ 
        {
          Nombre: 'Campo',
          id: 1,
        }
      ],
    },
    disableEditor: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    VueEditor,
    BaseElDialog,
    AccessibleElSelect,
  },
  data () {
    return {
      editorOptions: {
        modules: {
          toolbar: {
            container: '#customToolbar' + this.idDefault,
          }
        },
      },
      editorFocused: null,
      showModalUrl: false,
      showModalTag: false,
      content: '',
      form: {
        url: '',
        tag: '',
        auxText: '',
      },
      rules: {
        tag: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        metadatoAdicional: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        auxText: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        url: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ]
      }
    }
  },
  created () {
    this.reloadContent()
  },
  watch: {
    showModalUrl (newValue, oldValue) {
      if (!newValue) {
        this.form.url = ''
      }
    },
    showModalTag (newValue, oldValue) {
      if (!newValue) {
        this.form.tag = ''
        this.form.auxText =''
      }
    },
    contentDefault (newValue) {
      this.content = DOMPurify.sanitize(newValue, EDITOR_PURIFY_CONFIG)
    },
  },
  computed: {
    isSelectDropdownOpen () {
      return dropdownState.isAnyDropdownOpen
    },
    isSelectedType2 () {
      if (!this.form.tag) return false
      return this.tags.filter(x => x.Nombre === this.form.tag)[0].idTipo === 2
    },
    isSelectedType3 () {
      if (!this.form.tag) return false
      return this.tags.filter(x => x.Nombre === this.form.tag)[0].idTipo === 3
    },
    isSelectedType4 () {
      if (!this.form.tag) return false
      return this.tags.filter(x => x.Nombre === this.form.tag)[0].idTipo === 4
    },
    tagSelectedType4 () {
      if (!this.form.tag) return ''
      const selected = this.tags.filter(x => x.Nombre === this.form.tag)[0]
      if (!selected) return ''
      let res = selected.Tag
      if (this.isSelectedType4 && this.form?.metadatoAdicional) {
        res = res.replace('CAMPO_METADATO', this.form.metadatoAdicional)
      }
      return res
    },
    tagSelected () {
      if (!this.form.tag) return ''
      return this.tags.filter(x => x.Nombre === this.form.tag)[0].Tag
    },
    tagsForAccessibleSelect () {
      return this.tags.map(tag => ({
        id: tag.Nombre,
        name: tag.Nombre,
        value: tag.Nombre
      }))
    },
    metadatosAdicionalesForAccessibleSelect () {
      return this.metadatosAdicionales.map(item => ({
        id: item.id,
        name: item.Nombre,
        value: item.Nombre
      }))
    }
  },
  methods: {
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    reloadContent () {
      this.content = DOMPurify.sanitize(this.contentDefault, EDITOR_PURIFY_CONFIG)
    },
    onEditorFocus (quill) {
      this.editorFocused = quill
    },
    toggleAddImage () {
      if (this.disableEditor) return
      if (!this.editorFocused) {
        this.doFeedback('Ponga el cursor en el lugar donde desea insertar la imagen', 'info')
        return
      }
      this.showModalUrl = !this.showModalUrl
    },
    handleImageAdded (ruleForm) {
      if (this.disableEditor) return
      try {
        this.$refs[ruleForm].validate(async valid => {
          if (valid) {
            this.showModalUrl = false
            const safeUrl = this.form.url.trim()
            if (/^javascript:/i.test(safeUrl)) {
              this.doFeedback('URL no válida')
              return
            }
            this.editorFocused.insertEmbed(
              this.editorFocused.getSelection(true).index,
              'image',
              safeUrl,
              '')
          } else {
            this.doFeedback('Error al procesar los datos, revise la información')
          }
        })
      } catch (error) {
        this.doFeedback()
      }
    },
    getContent () {
      return this.content
    },
    getContentDifferent () {
      if (this.content === this.contentDefault) {
        return null
      }
      return this.content
    },
    exportHtml: async function () {
      if (this.disableEditor) return
      try {
        const blob = new Blob([this.content], { type: 'text/html', encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'cuerpo-correo.html'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.isLoadedExcel = true
      }
    },
    toggleInsertTag () {
      if (this.disableEditor) return
      if (!this.editorFocused) {
        this.doFeedback('Ponga el cursor en el lugar donde desea insertar la etiqueta', 'info')
        return
      }
      this.showModalTag = !this.showModalTag
    },
    insertTag: async function (ruleForm) {
      if (this.disableEditor) return
      try {
        this.$refs[ruleForm].validate(async valid => {
          if (valid) {
            this.showModalTag = false
            if (this.isSelectedType2) {
              this.editorFocused.insertText(
                this.editorFocused.getSelection(true).index, 
                this.form.auxText, 
                'link', 
                this.tagSelected)
              return
            }
            if (this.isSelectedType3 || this.isSelectedType4) {
              const actualTag = this.tags.filter(x => x.Nombre === this.form.tag)[0]
              this.editorFocused.insertText(
                this.editorFocused.getSelection(true).index, 
                actualTag.TagIni + this.form.auxText + ' ' + (this.isSelectedType4 ? this.tagSelectedType4 : this.tagSelected) + actualTag.TagFin)
              return
            }
            this.editorFocused.insertText(
              this.editorFocused.getSelection(true).index, 
              this.tagSelected)
          } else {
            this.doFeedback('Error al procesar los datos, revise la información')
          }
        })
      } catch (error) {
        this.doFeedback()
      }
    },
  }
}
</script>
